import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">


      <div className="footer-section">
        <div className="company1-logo-wrapper">
          <Link to="/" className="company1-logo" onClick={() => window.scrollTo(0, 0)}>Spatial</Link>
          <Link to="/" className="company1-logo-box" onClick={() => window.scrollTo(0, 0)}>CT</Link>
        </div>
        <p className="footer-description">
          Helping businesses step confidently into the AI-driven Spatial Computing Era (AR | VR | MR) – just like they once embraced desktop and mobile computing.
        </p>
      </div>
      <div className="footer-vertical-line"></div>

      <div className="footer-section">
        <div className="footer-title">Contact Us</div>
        <div className="footer-contact-row">
          <img src="images/location_icon.webp" alt="Location" className="footer-icon" />
          <div className="footer-location">
            <strong className='strong'>Spatial Computing Technologies Pvt. Ltd.</strong><br />
            <a href="https://maps.app.goo.gl/17sSK3P8sf8KouKp6" target="_blank" rel="noopener noreferrer" className="footer-link">
              VO-550, WeWork Olympia Cyberspace, No 21/22, Alandur Road, <br />
              Arulayiammanpet, 2nd Street, Guindy, Chennai 600032.
            </a>
          </div>
        </div>

        <div className="footer-contact-row">
          <img src="images/mobile_icon.webp" alt="Phone" className="footer-icon" />
          <a href="tel:+919769012101" className="footer-link" target='_blank'>+91 97690 12101</a>
        </div>


        <div className="footer-contact-row">
          <img src="images/email_icon.webp" alt="Email" className="footer-icon" />
          <a href="mailto:info@spatialct.co" className="footer-link" target='_blank'>info@spatialct.co</a>
        </div>
      </div>
      <div className="footer-vertical-line"></div>


      <div className="footer-section">
        <div className="footer-title">Follow Us</div>
        <div className="footer-social-icons">
          <a href="https://www.facebook.com/share/16KLhz163B/" target="_blank" rel="noopener noreferrer"><img src="images/fb_icon.webp" alt="Facebook" /></a>
          <a href="https://x.com/SpatialCT" target="_blank" rel="noopener noreferrer" className='twitter'><img src="images/twitter_icon.webp" alt="Twitter" /></a>
          <a href="https://www.linkedin.com/company/spatialct" target="_blank" rel="noopener noreferrer"><img src="images/LI_icon.webp" alt="LinkedIn" /></a>
          <a href="https://youtube.com/@spatialct?si=WSamOFV95zSfFSXj" target="_blank" rel="noopener noreferrer"><img src="images/YT_icon.webp" alt="YouTube" /></a>
        </div>
      </div>
      <p className='right-reserved'>© 2026 Spatial Computing Technologies Pvt. Ltd.</p>

    </footer>
  );
};

export default Footer;
